import Tents from './tents';
import ParticipantAssignment from './participant-assignment';

export default function TentPages(props) {
    return {
        Tents,
        ParticipantAssignment,
    };
}
